import React from 'react';

import { useTranslation } from 'react-i18next';

import { ErrorIcon, ErrorIconWrapper, ErrorSquare, ErrorText, ErrorWrapper } from './styles';

export interface NFTAssetErrorProps {
    errorSquareBackground?: boolean;
    noErrorText?: boolean;
}

export function NFTAssetError({ noErrorText, errorSquareBackground = true }: NFTAssetErrorProps) {
    const [translate] = useTranslation('groups');

    return (
        <ErrorWrapper>
            <ErrorSquare $background={errorSquareBackground}>
                <ErrorIconWrapper>
                    <ErrorIcon />
                </ErrorIconWrapper>
            </ErrorSquare>

            {noErrorText ? null : <ErrorText>{translate('groups_preview_unavailable')}</ErrorText>}
        </ErrorWrapper>
    );
}
